import { Company } from './company.model';

export class User{
  _id?: string;
  name?: string;
  surname?: string;
  email?: string;
  password?: string;
  roles?: string[];
  /** Raw ObjectId string when not populated; full Company object when populated by the API. */
  company?: string | Company;
  phone?: string;
  validated?: boolean;
  authorized?: boolean;
  phoneValidated?: boolean;
  jobTitle?: string;
  notification?: any;
  createdAt?: Date;
  updatedAt?: Date;
  customization?: {
    theme?: string;
    logoUrl?: string;
    companyName?: string;
  };
  onboardingCompleted?: Record<string, boolean>;
  requiresPhoneValidation?: boolean;
  selfServeProjectId?: string | null;
  /** True when this session is a superadmin "viewing as" this user. */
  viewingAs?: boolean;
}
